import React from 'react';

const Activities = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Activities</h1>
        <p>Our ongoing activities and initiatives</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>Daily News</h2>
              <p>Stay updated with our latest news and announcements.</p>
              <button className="btn-gold" onClick={() => window.location.href='/daily-news'}>View News</button>
            </div>
            <div className="content-card">
              <h2>Projects</h2>
              <p>Initiatives driving African development.</p>
              <button className="btn-gold" onClick={() => window.location.href='/projects'}>View Projects</button>
            </div>
            <div className="content-card">
              <h2>Gallery</h2>
              <p>Photos from our events and activities.</p>
              <button className="btn-gold" onClick={() => window.location.href='/gallery'}>View Gallery</button>
            </div>
            <div className="content-card">
              <h2>Corporate Activities</h2>
              <p>Our ongoing corporate initiatives.</p>
              <button className="btn-gold" onClick={() => window.location.href='/corporate-activities'}>View Activities</button>
            </div>
            <div className="content-card">
              <h2>Press Releases</h2>
              <p>Latest news and announcements.</p>
              <button className="btn-gold" onClick={() => window.location.href='/press-releases'}>View Releases</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Activities;